import { render, staticRenderFns } from "./NoteActions.vue?vue&type=template&id=1b895c56&"
import script from "./NoteActions.vue?vue&type=script&lang=js&"
export * from "./NoteActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports